export const employmentTypeOptions = [
  { label: 'Select', value: '' },
  { label: 'Full-time', value: 'full-time' },
  { label: 'Part-time', value: 'part-time' },
  { label: 'Contract', value: 'contract' }
];

export const experienceOptions = [
  { label: 'Flexible / Open to All', value: 'flexible' },
  { label: 'Entry Level (Fresher)', value: 'entry-level' },
  { label: '1–2 Years', value: '1-2-years' },
  { label: '3–5 Years', value: '3-5-years' },
  { label: '5–7 Years', value: '5-7-years' },
  { label: '7+ Years', value: '7-plus-years' }
];

export const modeOfWorkOptions = [
  { label: 'Select', value: '' },
  { label: 'Remote', value: 'Remote' },
  { label: 'Onsite', value: 'Onsite' },
  { label: 'Hybrid', value: 'Hybrid' }
];

export const qualificationOptions = [
  { label: 'Select', value: '' },
  {
    label: 'High School/Secondary Education',
    value: 'High School/Secondary Education'
  },
  { label: 'Undergraduate Degrees', value: 'Undergraduate Degrees' },
  {
    label: 'Professional Certifications',
    value: 'Professional Certifications'
  },
  {
    label: 'Vocational and Technical Education',
    value: 'Vocational and Technical Education'
  },
  {
    label: 'Research and Doctoral Studies',
    value: 'Research and Doctoral Studies'
  }
];
